import { useLocale } from '@koopajs/react';
import { IResolution } from 'types';
import React from 'react';
import { VisibleByAccordion } from 'components/VisibleByAccordion';

interface IResolutionVisibleByProps {
  resolution: IResolution;
}

export const ResolutionVisibleByAccordion: React.FC<IResolutionVisibleByProps> = (props) => {
  const { resolution } = props;

  const { t } = useLocale();
  const keyPrefix = 'WrittenResolution';

  const activeCommitteeMembersWithCreateResolutionRole = resolution?.activeCommitteeMembers?.filter((acm) => {
    return acm.roles?.some((role) => role.role === 'createResolutionProjects');
  });

  const usersVisibleByIds = activeCommitteeMembersWithCreateResolutionRole?.map((acm) => acm.userId);

  return (
    <VisibleByAccordion
      title={t('common:writtenResolution')}
      usersVisibleByIds={usersVisibleByIds}
      visibleByState="some"
      chip={{
        label: t(keyPrefix + '.accordionChipToReviewLabel'),
        sx: { backgroundColor: 'customGrey.main' }
      }}
      prefixVisibleToSome={t(keyPrefix + '.prefixVisibleToSome')}
      prefixVisibleToAll={t(keyPrefix + '.prefixVisibleToAll')}
    />
  );
};
